<template>
  <div v-if="issue && issue.id" class="modal-content product-list-modal">
    <div class="modal-header">
      <h5 id="modalLabel" class="modal-title">
        Repuestos
      </h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div v-if="!issueProductList.productLines || !issueProductList.productLines.length" class="empty-hint">
        Sin repuestos cargados.
      </div>
      <div v-else class="product-lines">
        <div v-for="(product, index) in issueProductList.productLines" :key="index" class="product-row">
          <div class="product-name">
            {{product.product.name}}
          </div>
          <div class="product-price">
            <span v-if="edit[product.id] || product.product.priceType === 'SETTEABLE' && !product.price" class="price-edit">
              <input v-model="product.priceClone" type="number" placeholder="Precio" class="form-control">
              <button class="btn btn-success btn-sm" @click="setProductPrice(product)">
                Guardar
              </button>
            </span>
            <span v-else-if="product.product.priceType === 'SETTEABLE'" class="price-edit">
              <span class="price-amount">$ {{product.price}}</span>
              <button v-if="issue.active" class="btn btn-warning btn-sm" @click="toggleEditMode(product)">
                Cambiar
              </button>
            </span>
            <span v-else class="price-amount">$ {{product.price}}</span>
          </div>
          <button v-if="issue.active" type="button" class="btn btn-outline-danger btn-sm btn-remove" @click="removeProduct(product.id)">
            Quitar
          </button>
        </div>
      </div>
      <div v-if="totalPrice > 0" class="product-total">
        <span>Precio Total</span>
        <b>$ {{totalPrice}}</b>
      </div>

      <div v-if="issue.active" class="add-products">
        <h5>
          Agregar Repuestos
        </h5>
        <div class="search-field">
          <div class="search-input-wrap">
            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input type="text" class="form-control search-input" placeholder="Busque producto aquí." @keyup="getProducts">
          </div>
          <button class="btn btn-outline-secondary" @click="forceGetProducts">
            Traer más repuestos
          </button>
        </div>

        <h6 class="add-products-subtitle">
          O agregarlo aquí
        </h6>
        <div class="quick-add-row">
          <div class="field-currency">
            <label for="cost">Costo</label>
            <div class="currency-input">
              <span>$</span>
              <input id="cost" v-model="draftProd.cost" type="number" placeholder="0" name="cost">
            </div>
          </div>
          <div class="field-currency">
            <label for="price">Precio al cliente</label>
            <div class="currency-input">
              <span>$</span>
              <input id="price" v-model="draftProd.price" placeholder="0" name="price">
            </div>
          </div>
          <button class="btn btn-success quick-add-btn" @click="createProductOnTheFly">
            Agregarlo
          </button>
        </div>

        <div v-if="searchProducts.length" class="product-lines search-results">
          <div v-for="(product, index) in searchProducts" :key="index" class="product-row">
            <div class="product-name">
              {{product.description}}
            </div>
            <div class="product-price">
              <span v-if="product.priceType === 'SETTEABLE'" class="price-amount price-variable">
                Precio Variable
              </span>
              <span v-else class="price-amount">$ {{product.price}}</span>
            </div>
            <button type="button" class="btn btn-success btn-sm" @click="addProduct(product)">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">
        OK
      </button>
    </div>
  </div>

  <div v-else>
    <p>Vacío o sin seleccionar.</p>
  </div>
</template>

<script>
import ProductService from '@/services/product.service';

export default {
    name: 'IssueProductList',
    props: {
        issue: Object
    },
    data() {
        return {
            products: [],
            draftProd: {
                description: 'Generico',
                price: '',
                cost: '',
                priceType: 1,
                code: '-1'
            },
            searchProducts: [],
            issueProductList: {},
            totalPrice: 0,
            edit: {}
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    // This was loading when the Ticket was accessed, not needed if we aren't going to use it.
    // created() {
    //     this.initProducListComponent();
    // },
    methods: {
        initProducListComponent() {
            this.edit = {};
            this.getProductList();
        },
        getProductList() {
            var self = this;
            self.totalPrice = 0;
            ProductService.getProductList(this.issue.id).then(
                response => {
                    this.issueProductList = response.data;
                    this.issueProductList.productLines.forEach(plist => {
                        self.totalPrice += plist.price;
                    });
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        forceGetProducts() {
            this.setProductList();
        },
        setProductList(value) {
            // only get active products here.
            ProductService.getProducts(true).then(
                response => {
                    this.products = response.data;
                    if (value) {
                        this.searchProducts = this.products.filter(product => {
                            return product.name.toLowerCase().includes(value.toLowerCase()) ||
                            product.description.toLowerCase().includes(value.toLowerCase()) ||
                                product.code.toLowerCase().includes(value.toLowerCase());
                        });
                    } else {
                        this.searchProducts = this.products;
                    }
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        getProducts(e) {
            if (e.target.value.length > 2) {
                if (!this.products.length) {
                    this.setProductList(e.target.value);
                } else {
                    this.searchProducts = this.products.filter(product => {
                        return product.description.toLowerCase().includes(e.target.value.toLowerCase());
                    });
                }
            }
        },
        createProductOnTheFly() {
            var self = this;
            ProductService.saveProduct(this.draftProd)
                .then(response => {
                    this.draftProd.id = response.data.id;

                    self.addProduct(response.data);
                    setTimeout(function forceControl() {
                        self.draftProd = {
                            description: 'Generico',
                            price: '',
                            cost: '',
                            priceType: 1,
                            code: '-1'
                        };
                    }, 1000);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                });
        },
        addProduct(product) {
            var self = this;
            ProductService.postProductsList(this.issue.id, product).then(
                response => {
                    this.issueProductList = response.data;
                    self.totalPrice = 0;
                    this.issueProductList.productLines.forEach(plist => {
                        self.totalPrice += plist.price;
                    });
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        setProductPrice(product) {
            product.price = product.priceClone;
            ProductService.updateProductListItem(product.id, product).then(
                response => {
                    // done!
                    this.edit[product.id] = false;
                    this.getProductList();
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        toggleEditMode(product) {
            this.edit[product.id] = true;
            this.getProductList();
        },
        removeProduct(productId) {
            var self = this;
            ProductService.removeProductFromProductList(this.issue.id, productId).then(
                response => {

                    this.issueProductList.productLines = this.issueProductList.productLines.filter(product => {
                        return product.id !== productId;
                    });
                    self.totalPrice = 0;
                    this.issueProductList.productLines.forEach(plist => {
                        self.totalPrice += plist.price;
                    });
                    // remove from the represented list.
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        }
    /* eslint-disable no-console */
    }
};
</script>
<style lang="scss">
@import "../../../styles/theme.scss";

.product-list-modal {
    .modal-body {
        padding: 18px 20px;
    }

    h5 {
        font-size: 13px;
        font-weight: 700;
        color: $issue-text;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        margin: 0 0 12px;
    }

    .empty-hint {
        padding: 10px 2px 18px;
        color: $issue-text-muted;
        font-size: 13.5px;
        font-style: italic;
    }

    .product-lines {
        border: 1px solid $issue-border;
        border-radius: $issue-radius-sm;
        overflow: hidden;
        margin-bottom: 16px;
    }

    .product-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px 12px;
        padding: 10px 12px;
        border-bottom: 1px solid $issue-border;
        font-size: 13.5px;

        &:last-child {
            border-bottom: none;
        }
        &:nth-child(odd) {
            background-color: $issue-bg-subtle;
        }
    }

    .product-name {
        flex: 1 1 200px;
        min-width: 0;
        color: $issue-text;
    }

    .product-price {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
    }

    .price-amount {
        font-weight: 600;
        color: $issue-text;
        white-space: nowrap;
    }

    .price-variable {
        font-weight: 400;
        font-style: italic;
        color: $issue-text-muted;
    }

    .price-edit {
        display: flex;
        align-items: center;
        gap: 6px;

        .form-control {
            width: 100px;
            padding: 5px 8px;
            font-size: 13px;
            border: 1px solid darken($issue-border, 6%);
            border-radius: $issue-radius-sm;
            &:focus {
                border-color: $issue-primary;
                box-shadow: 0 0 0 3px $issue-primary-soft;
                outline: none;
            }
        }
    }

    .btn-remove {
        flex: 0 0 auto;
    }

    .product-total {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 14px;
        margin-bottom: 20px;
        background-color: $issue-primary-soft;
        border-radius: $issue-radius-sm;
        font-size: 13.5px;
        color: $issue-text;

        b {
            font-size: 16px;
        }
    }

    .add-products {
        padding-top: 16px;
        border-top: 1px solid $issue-border;
    }

    .search-field {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 18px;

        .search-input-wrap {
            position: relative;
            flex: 1 1 220px;
            min-width: 0;
            display: flex;
            align-items: center;
        }

        .search-icon {
            position: absolute;
            right: 13px;
            top: 50%;
            width: 15px;
            height: 15px;
            transform: translateY(-50%);
            color: $issue-text-muted;
            pointer-events: none;
        }

        .search-input {
            width: 100%;
            padding: 7px 37px 7px 12px;
            border: 1px solid darken($issue-border, 6%);
            border-radius: $issue-radius-sm;
            font-size: 13.5px;
            &:focus {
                border-color: $issue-primary;
                box-shadow: 0 0 0 3px $issue-primary-soft;
                outline: none;
            }
        }

        .btn {
            flex: 0 0 auto;
            white-space: nowrap;
            font-size: 12.5px;
        }
    }

    .add-products-subtitle {
        font-size: 11.5px;
        font-weight: 700;
        color: $issue-text-muted;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-bottom: 10px;
    }

    .quick-add-row {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 18px;
        padding: 12px;
        background-color: $issue-bg-subtle;
        border-radius: $issue-radius-sm;
    }

    .field-currency {
        flex: 1 1 140px;
        min-width: 120px;

        label {
            display: block;
            margin-bottom: 4px;
            font-size: 12px;
            font-weight: 600;
            color: $issue-text-muted;
        }
    }

    .currency-input {
        display: flex;
        align-items: stretch;
        border: 1px solid darken($issue-border, 6%);
        border-radius: $issue-radius-sm;
        background-color: #fff;
        overflow: hidden;
        transition: border-color .12s ease, box-shadow .12s ease;

        &:focus-within {
            border-color: $issue-primary;
            box-shadow: 0 0 0 3px $issue-primary-soft;
        }

        span {
            display: flex;
            align-items: center;
            padding: 0 10px;
            background-color: $issue-bg-subtle;
            color: $issue-text-muted;
            font-size: 13px;
            font-weight: 600;
        }

        input {
            flex: 1 1 auto;
            min-width: 0;
            width: 100%;
            border: none;
            padding: 7px 10px;
            font-size: 13.5px;
            background: transparent;
            &:focus {
                outline: none;
            }
        }
    }

    .quick-add-btn {
        flex: 0 0 auto;
        align-self: flex-end;
    }

    @media(max-width: 600px) {
        .search-field .btn {
            flex: 1 1 100%;
        }
        .quick-add-row {
            .field-currency {
                flex-basis: 100%;
            }
            .quick-add-btn {
                flex-basis: 100%;
            }
        }
        .product-row {
            .product-name {
                flex-basis: 100%;
            }
        }
    }
}
</style>
